export default "varying vec2 vUv;\r\n\r\nvoid main(){\r\n  vUv=uv;\r\n  gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.);\r\n}";